//
// Reel manager class
//
// Used to create and manage reels
// New functionality for cascade reel

Reflex.deregisterEventHandler('resize', reelManager.onResize);

reelManager.createCascadeReel = function (json) {
  var reel = cascadeReelTemplate.createReel(
    -1,
    json,
    gameController.onSymbolLandedCallback,
    gameController.onSymbolDroppedCallback
  );
  reelManager.reels.push(reel);
  return reel;
};

reelManager.onResize = function () {
  for (var i = 0; i < reelManager.reels.length; ++i) {
    reelManager.reels[i].updateSymbols('onResize');
  }
};

Reflex.registerEventHandler('resize', reelManager.onResize);

resourceManager.registerObjectType(
  'cascadeReel',
  reelManager.createCascadeReel,
  reelManager.initialiseReel,
  reelManager.getReelFiles,
  reelManager.destroyReel
);
